var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 8.18182C16.3636 14.5455 8.18182 20 8.18182 20C8.18182 20 0 14.5455 0 8.18182C3.23348e-08 6.01187 0.86201 3.93079 2.3964 2.3964C3.93079 0.86201 6.01187 0 8.18182 0C10.3518 0 12.4328 0.86201 13.9672 2.3964C15.5016 3.93079 16.3636 6.01187 16.3636 8.18182Z",
    fill: "#1DB960"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinGreen);
export default __webpack_public_path__ + "static/media/map-pin-green.b4e839af8c3e2dc02893bb3a384b727a.svg";
export { ForwardRef as ReactComponent };